'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FolderLoader = exports.create = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _loader = require('./loader');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Called usually once per request to create the caches responsible for holding
// on to data.
var create = exports.create = function create(_ref) {
  var network = _ref.network;
  return {
    library: Library({ network: network }),
    libraryFolders: LibraryFolders({ network: network }),
    folder: Folder({ network: network }),
    document: Document({ network: network })
  };
};

var Library = function Library(_ref2) {
  var network = _ref2.network;
  return new LibraryLoader({ network: network });
};

var LibraryLoader = function (_BatchLoader) {
  (0, _inherits3.default)(LibraryLoader, _BatchLoader);

  function LibraryLoader(_ref3) {
    var network = _ref3.network,
        autoDispatch = _ref3.autoDispatch;
    (0, _classCallCheck3.default)(this, LibraryLoader);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LibraryLoader.__proto__ || (0, _getPrototypeOf2.default)(LibraryLoader)).call(this, { autoDispatch: autoDispatch }));

    _this.network = network;
    return _this;
  }

  (0, _createClass3.default)(LibraryLoader, [{
    key: 'batchLoad',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(queue) {
        var _this2 = this;

        var network, gettingAll, all;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                network = this.network;

                // find minimum required work, we will only have one qualifying promise
                // because of the cache

                gettingAll = queue.length > 1 || queue.some(function (_ref5) {
                  var extras = _ref5.extras;
                  return extras === 'all';
                });

                if (!gettingAll) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 5;
                return network.request('libraries');

              case 5:
                all = _context2.sent;


                queue.forEach(function (_ref6) {
                  var id = _ref6.id,
                      extras = _ref6.extras,
                      resolve = _ref6.resolve,
                      reject = _ref6.reject;

                  if (extras === 'all') {
                    resolve(all);
                  }

                  var lib = all.find(function (lib) {
                    return lib['LibraryId'] == id;
                  });
                  if (!lib) {
                    reject(new TypeError('The library with id ' + id + ' can\'t be found.'));
                  }

                  resolve(lib);
                });
                _context2.next = 12;
                break;

              case 9:
                _context2.next = 11;
                return _promise2.default.all(queue.map(function () {
                  var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(_ref8) {
                    var id = _ref8.id,
                        resolve = _ref8.resolve,
                        reject = _ref8.reject;
                    var body;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return network.request('libraries/' + id);

                          case 3:
                            body = _context.sent;

                            resolve(body);
                            _context.next = 10;
                            break;

                          case 7:
                            _context.prev = 7;
                            _context.t0 = _context['catch'](0);

                            reject(_context.t0);

                          case 10:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2, [[0, 7]]);
                  }));

                  return function (_x2) {
                    return _ref7.apply(this, arguments);
                  };
                }()));

              case 11:
                return _context2.abrupt('return', _context2.sent);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function batchLoad(_x) {
        return _ref4.apply(this, arguments);
      }

      return batchLoad;
    }()
  }]);
  return LibraryLoader;
}(_loader.BatchLoader);

var LibraryFolders = function LibraryFolders(_ref9) {
  var network = _ref9.network;
  return new _loader.Loader({
    fetchFn: function () {
      var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(id) {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return network.request('libraries/' + id + '/folders');

              case 2:
                return _context3.abrupt('return', _context3.sent);

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, undefined);
      }));

      return function fetchFn(_x3) {
        return _ref10.apply(this, arguments);
      };
    }()
  });
};

var Folder = function Folder(_ref11) {
  var network = _ref11.network;
  return new FolderLoader({ network: network });
};

var FolderLoader = exports.FolderLoader = function (_BatchLoader2) {
  (0, _inherits3.default)(FolderLoader, _BatchLoader2);

  function FolderLoader(_ref12) {
    var network = _ref12.network,
        autoDispatch = _ref12.autoDispatch;
    (0, _classCallCheck3.default)(this, FolderLoader);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (FolderLoader.__proto__ || (0, _getPrototypeOf2.default)(FolderLoader)).call(this, { autoDispatch: autoDispatch }));

    _this3.network = network;
    return _this3;
  }

  (0, _createClass3.default)(FolderLoader, [{
    key: 'getFromCache',
    value: function getFromCache(id, _ref13) {
      var needFolders = _ref13.folders,
          needDocs = _ref13.documents;

      var cached = this.cache.get(id);
      if (!cached) {
        return null;
      }

      var extras = cached.extras,
          promise = cached.promise;
      var hasFolders = extras.folders,
          hasDocs = extras.documents;

      // ensure that the extras for the cached request are better than or equal to
      // the one requested

      if (needFolders && !hasFolders) {
        return null;
      }

      if (needDocs && !hasDocs) {
        return null;
      }

      return promise;
    }
  }, {
    key: 'batchLoad',
    value: function () {
      var _ref14 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(queue) {
        var _this4 = this;

        var network, reqs;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                network = this.network;

                // reduce into minimum required requests

                reqs = queue.reduce(function (acc, _ref15) {
                  var id = _ref15.id,
                      rExtras = _ref15.extras,
                      resolve = _ref15.resolve,
                      reject = _ref15.reject;

                  var _ref16 = acc[id] || {},
                      _ref16$promiseFuncs = _ref16.promiseFuncs,
                      promiseFuncs = _ref16$promiseFuncs === undefined ? [] : _ref16$promiseFuncs,
                      _ref16$extras = _ref16.extras,
                      extras = _ref16$extras === undefined ? {} : _ref16$extras;

                  // update


                  promiseFuncs.push({ resolve: resolve, reject: reject });
                  (0, _assign2.default)(extras, (0, _utils.filter)(rExtras));

                  acc[id] = { promiseFuncs: promiseFuncs, extras: extras };
                  return acc;
                }, {});
                _context5.next = 4;
                return _promise2.default.all((0, _entries2.default)(reqs).map(function () {
                  var _ref17 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(_ref18) {
                    var _ref19 = (0, _slicedToArray3.default)(_ref18, 2),
                        id = _ref19[0],
                        _ref19$ = _ref19[1],
                        promiseFuncs = _ref19$.promiseFuncs,
                        _ref19$$extras = _ref19$.extras,
                        folders = _ref19$$extras.folders,
                        documents = _ref19$$extras.documents;

                    var paramsString, path, body;
                    return _regenerator2.default.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.prev = 0;
                            paramsString = (0, _keys2.default)((0, _utils.filter)({ 'f': folders, 'd': documents })).join();
                            path = 'folders/' + id + (paramsString && '?embed=' + paramsString);
                            _context4.next = 5;
                            return network.request(path);

                          case 5:
                            body = _context4.sent;


                            promiseFuncs.forEach(function (_ref20) {
                              var resolve = _ref20.resolve;
                              return resolve(body);
                            });
                            _context4.next = 12;
                            break;

                          case 9:
                            _context4.prev = 9;
                            _context4.t0 = _context4['catch'](0);

                            promiseFuncs.forEach(function (_ref21) {
                              var reject = _ref21.reject;
                              return reject(_context4.t0);
                            });

                          case 12:
                          case 'end':
                            return _context4.stop();
                        }
                      }
                    }, _callee4, _this4, [[0, 9]]);
                  }));

                  return function (_x5) {
                    return _ref17.apply(this, arguments);
                  };
                }()));

              case 4:
                return _context5.abrupt('return', _context5.sent);

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function batchLoad(_x4) {
        return _ref14.apply(this, arguments);
      }

      return batchLoad;
    }()
  }]);
  return FolderLoader;
}(_loader.BatchLoader);

var Document = function Document(_ref22) {
  var network = _ref22.network;
  return new _loader.Loader({
    fetchFn: function () {
      var _ref23 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(id) {
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return network.request('documents/' + id);

              case 2:
                return _context6.abrupt('return', _context6.sent);

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, undefined);
      }));

      return function fetchFn(_x6) {
        return _ref23.apply(this, arguments);
      };
    }()
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/nice-sharebase/lib/loaders.js
// module id = 549
// module chunks = 0